import { z } from "zod";

const couponSchema = z.object({
  couponKey: z.string(),
  percentage: z.coerce.number(),
  fixDiscount: z.coerce.number(),
  machines: z.enum(["mosogep", "ozon", "szaritogep"]).array(),
  capacities: z.any().array(),
  /** The code the user redeemed; missing on coupons stored by older builds. */
  code: z.string().optional(),
});

export function useCoupon() {
  return getActiveCoupon();
}

export function getActiveCoupon() {
  const coupon = sessionStorage.getItem("coupon");
  if (!coupon) {
    return null;
  }

  try {
    return couponSchema.parse(JSON.parse(coupon));
  } catch (e) {
    console.error(e);
    sessionStorage.removeItem("coupon");
    return null;
  }
}
